function normalizeBaseUrl(rawUrl) {
  let url = String(rawUrl || '').trim();
  if (!url) return '';
  if (url.endsWith('/')) url = url.slice(0, -1);
  return url.replace(/\/v1\/admin$/i, '');
}

/** Admin-service origin (set via REACT_APP_API_URL at build time). */
export function getApiBaseUrl() {
  return normalizeBaseUrl(process.env.REACT_APP_API_URL);
}
